export default __webpack_public_path__ + "static/media/navbar-pikachu.74654047.gif";